enum RemarkType {
    Dot = "dot",
    Annotation = "annotation",
    ApprovalNote = "approvalNote",
    AIReviewDot = "aiReviewDot",
}

export default RemarkType;
